export const WELCOME_ONBOARDING_PATH = "/auto-quote";
// Retain the optional example-project introduction and its attribution.
export const FIRST_QUOTE_ONBOARDING_PATH = "/quotes/new?first_quote=1";
export const TEST_QUOTE_SIGNUP_PATH = `/login?returnTo=${encodeURIComponent(WELCOME_ONBOARDING_PATH)}`;
export const TEST_QUOTE_GENERATION_SOURCE = "test_quote_introduction";

export function getTestQuoteGenerationSource(
  guestMode: boolean,
  search: string,
): typeof TEST_QUOTE_GENERATION_SOURCE | undefined {
  if (guestMode) return undefined;
  return new URLSearchParams(search).get("first_quote") === "1"
    ? TEST_QUOTE_GENERATION_SOURCE
    : undefined;
}

export function getTryAQuoteDestination(isAuthenticated: boolean): string {
  return isAuthenticated ? "/quotes/new" : TEST_QUOTE_SIGNUP_PATH;
}

export function getPostLoginDestination(returnTo: string | null): string {
  if (!returnTo) return "/";
  const parsed = new URL(returnTo, "https://thepropertool.com");
  if (parsed.pathname !== "/quotes/new") return returnTo;
  parsed.searchParams.delete("first_quote");
  return `${parsed.pathname}${parsed.search}${parsed.hash}`;
}

export function getPostRegistrationDestination(returnTo: string | null, fbEventId?: string): string {
  if (returnTo === "/try-a-quote/claim") return returnTo;
  const parsed = new URL(WELCOME_ONBOARDING_PATH, "https://thepropertool.com");
  parsed.searchParams.set("new_signup", "1");
  if (fbEventId) parsed.searchParams.set("fb_event_id", fbEventId);
  return `${parsed.pathname}${parsed.search}`;
}
